import React, { useState } from 'react'
import { format, addMinutes, set } from 'date-fns'
import Flatpickr from 'react-flatpickr'
import Timeslot from './Timeslot'
import { parseDate } from 'helpers/date_input_helper'

// hide the input field displayed by default
const CustomInput = ({ value, defaultValue, inputRef, ...props }) => {
  return <input {...props} defaultValue={defaultValue} ref={inputRef} className='d-none' />
}

export default function EventTimeSlotScheduler ({ timeslots_list }) {
  const [state, setState] = useState(() => {
    return {
      timeslotsList: timeslots_list
    }
  })

  const customDateSelected = (selectedDates, dateStr, instance) => {
    let sortedDates = selectedDates
      .slice()
      .sort((a, b) => b - a)
      .reverse()

    let datesAsObjects = []
    sortedDates.map(t => {
      const dt = format(t, 'MMMM d, yyyy h:mm aaa')
      const existingTimeslot = state.timeslotsList.find(x => x.start_at === dt)
      const startAt = existingTimeslot?.start_at || set(t, { hours: 9, minutes: 0, seconds: 0 })
      const duration = parseInt(existingTimeslot?.duration || 120)
      datesAsObjects.push({ start_at: startAt, duration: duration })
    })

    setState((state) => ({ timeslotsList: datesAsObjects }))
  }

  const formatTimeslotProps = datetime => {
    const startDate = parseDate(datetime.start_at)
    return {
      // timeslots present on object
      startAt: startDate,
      duration: parseInt(datetime.duration),
      endAt: addMinutes(startDate, parseInt(datetime.duration))
    }
  }

  const flatpickrOptions = () => {
    return {
      inline: true,
      mode: 'multiple',
      defaultDate:
        state.timeslotsList.length === 0
          ? null
          : state.timeslotsList.map(timeslot => parseDate(timeslot.start_at)),
      onChange: (selectedDates, dateStr, instance) => customDateSelected(selectedDates, dateStr, instance)
    }
  }

  return (
    <div className='d-flex flex-row'>
      <div className='col-3 timeslot-calendar-container'>
        <Flatpickr
          options={flatpickrOptions()}
          render={
            ({defaultValue, value, ...props}, ref) => {
              return <CustomInput defaultValue={defaultValue} inputRef={ref} />
            }
          }
        />
      </div>

      <div className='col-9 timeslots-list-container'>
        <span>{`${state.timeslotsList.length} sessions total`}</span>
        <hr></hr>
        <ul className='list-group align-middle'>
          {
            state.timeslotsList.map((datetime, index) =>
              <Timeslot
                key={formatTimeslotProps(datetime).startAt}
                index={index + 1}
                startAt={formatTimeslotProps(datetime).startAt}
                duration={formatTimeslotProps(datetime).duration}
                endAt={formatTimeslotProps(datetime).endAt}
              />
            )
          }
        </ul>
      </div>
    </div>
  )
}
